<app-ga-metric *ngIf="googleAnalyticsCodes$ | async as codes" [codes]="codes"></app-ga-metric>
